export const AUTH_ERROR = '[app] AUTH Error'

export const authError = () => ({
  type: AUTH_ERROR
})